export const tabs = [
  {
    name: "Home",
    permission_name:"Home",
    route: "/homepage",
    icon: "fas fa-home",
    subtitle: "Welcome",
    display_Flg: "Y",
    product:"",
  },
  {
    name: "Marketplace",
    permission_name:"marketplace",
    route: "/marketplace",
    icon: "fas fa-store",
    subtitle: "Best Content Available",
    display_Flg: "Y",
    product:"Engage",
  },
  {
    name: "Meditation",
    permission_name:"meditation",
    route: "/meditation",
    icon: "fas fa-spa",
    subtitle: "",
    display_Flg: "Y",
    product:"Engage",
  },
  {
    name: "Create Activity",
    permission_name:"create_activity",
    route: "/create-activity",
    icon: "fas fa-magic",
    subtitle: "Plan Your New Event",
    display_Flg: "Y",
    product:"Engage",
  },
  {
    name: "Activity Formats",
    permission_name:"activity_formats",
    route: "/gamesdashboard",
    icon: "fas fa-layer-group",
    subtitle: "",
    display_Flg: "Y",
    product:"Engage",
  },
  {
    name: "Rewards",
    permission_name:"rewards",
    route: "/rewards",
    icon: "fas fa-trophy",
    subtitle: "Earn Points & Win",
    display_Flg: "N",
    disabled: true,
    product:"Engage",
  },
  {
    name: "Live Events",
    permission_name:"events",
    route: "/live-events",
    icon: "fas fa-calendar-alt",
    subtitle: "Upcoming Events",
    display_Flg: "N",
    disabled: true,
    product:"Engage",
  },
  {
    name: "Interviews",
    permission_name:"interviews",
    route: "/interviews",
    icon: "fas fa-clipboard-list",
    subtitle: "Plan Your Interview",
    display_Flg: "Y",
    disabled: false,
    product:"Interview",
  },
  {
    name: "Library",
    permission_name:"problemlibrary",
    route: "/interviews/library",
    icon: "fas fa-book-open",
    subtitle: "Browse Problem Library",
    display_Flg: "Y",
    disabled: false,
    product:"Interview",
  },
  {
    name: "Customize",
    permission_name:"problemcustomize",
    route: "/interviews/Customize",
    icon: "fas fa-magic",
    subtitle: "Create Custom Problems",
    display_Flg: "Y",
    disabled: false,
    product:"Interview",
  },
  {
    name: "AI Resume Screener",
    permission_name: "resumescreener",
    route: "/interviews/resume-screener",
    icon: "fas fa-user-check", // Represents AI-driven profile/resume screening
    subtitle: "Screen Candidate Resumes with AI",
    display_Flg: "Y",
    disabled: true,
    product: "Interview",
  }
];
